import React from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { Translate } from 'core/translate';
import { SvgIcon } from 'core/icons';
import { combineClassNames, Themed } from 'core/css';
import LoadImage from '../../common/images/LoadImage';

const PreviousLink = ({ description, itemId, packageId, visible }) => {
  if (!visible) {
    return null;
  }

  return (
    <Themed gmc="button button--link button--invert">
      {theme => (
        <Link
          to={`/packages/package/${packageId}/item/${itemId}`}
          className={combineClassNames(
            'package-details__previous',
            'stat-arrow-prev',
            theme
          )}
          data-dtm={description}>
          <SvgIcon
            name="chevron-left"
            className="package-details__controls-arrow"
          />
          <div className="show-for-large package-details__controls-arrow-label">
            <Translate value="byo.page.general.package.prev" />
          </div>
        </Link>
      )}
    </Themed>
  );
};

const NextLink = ({ description, itemId, packageId, visible }) => {
  if (!visible) {
    return null;
  }

  return (
    <Themed gmc="button button--link button--invert">
      {theme => (
        <Link
          to={`/packages/package/${packageId}/item/${itemId}`}
          className={combineClassNames(
            'package-details__next',
            'stat-arrow-next',
            theme
          )}
          data-dtm={description}>
          <SvgIcon
            name="chevron-right"
            className="package-details__controls-arrow"
          />
          <div className="show-for-large package-details__controls-arrow-label">
            <Translate value="byo.page.general.package.next" />
          </div>{' '}
        </Link>
      )}
    </Themed>
  );
};

const PackageItemsControl = ({
  packageOptions,
  option,
  optionDescription,
  packageId
}) => {
  if (packageOptions.length <= 0) {
    return null;
  }
  const optionHeader =
    option.displayName || option.description || option.primaryName;

  const currIndex = packageOptions.indexOf(option);
  const prevItem = packageOptions[currIndex - 1] || _.last(packageOptions);
  const nextItem = packageOptions[currIndex + 1] || _.first(packageOptions);

  return (
    <div className="package-details__controls">
      <PreviousLink
        description={optionDescription}
        itemId={prevItem.id}
        packageId={packageId}
        visible={packageOptions.length > 1}
      />
      <div
        className="package-details__controls-text"
        dangerouslySetInnerHTML={{ __html: optionHeader }}
      />
      <NextLink
        description={optionDescription}
        itemId={nextItem.id}
        packageId={packageId}
        visible={packageOptions.length > 1}
      />
    </div>
  );
};

const PackageDetailsItem = ({
  optionDescription,
  packageId,
  itemId,
  packageOptions
}) => {
  if (!packageOptions.length) {
    return null;
  }

  const option = _.find(packageOptions, { id: itemId });

  if (!option) {
    return null;
  }

  const imageText = option.description;

  return (
    <div className="modal-body__image-container modal-body__image-container--fit">
      <div className="package-details-main">
        <div className="package-carousel">
          <div className="package-carousel__image-container">
            <div className="package-carousel__image-container-inner">
              <LoadImage url={option.largeImageUrl}>
                {({ isLoading }) => {
                  if (isLoading) {
                    return (
                      <div className="loader package-details__loader">
                        <img className="hidden" src={option.largeImageUrl} />
                      </div>
                    );
                  }
                  return (
                    <img
                      src={option.largeImageUrl}
                      alt={imageText}
                      className="modal__image package-carousel__image"
                    />
                  );
                }}
              </LoadImage>
            </div>
          </div>

          <PackageItemsControl
            optionDescription={optionDescription}
            packageOptions={packageOptions}
            option={option}
            packageId={packageId}
          />
        </div>
      </div>
    </div>
  );
};

export default PackageDetailsItem;
